import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=b3302ed4&scoped=true&"
import script from "./invoice-detail.vue?vue&type=script&lang=js&"
export * from "./invoice-detail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-detail.vue?vue&type=style&index=0&id=b3302ed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3302ed4",
  null
  
)

export default component.exports